




























import { Vue, Prop, Component } from 'vue-property-decorator';
import moment from 'moment';
import InvoicePaymentLinkItem from '@/domain/billing/entity/invoice-payment-link/invoice-payment-link-item'
import headers from './payment-link-table-headers.json';

@Component
export default class BillingInfoContentPaymentLinkList extends Vue {
  @Prop({ type: Array, required: true })
  paymentLinks!: InvoicePaymentLinkItem[];

  @Prop({ type: Boolean, default: false })
  loading!: boolean

  headers: any[] = headers;

  toDateTime(createdDate: string): string {
    return moment(createdDate).format('DD/MM/YYYY HH:mm:ss');
  }

  copyLinkToClipboard(link: string): void {
    navigator.clipboard.writeText(link).then(() => {
      this.$emit('showSnackbar');
    });
  }
}
